import { DataEntry } from "./DataEntry";

export class FireExtinguisherDE extends DataEntry {
  numberOfExtinguisher: number;
  quantityOfCO2makeup: any;
  fireExtinguisherID: string;
}